'use client'

import React, { useMemo } from 'react'
import { useLocale, useTranslations } from 'next-intl'

import trendingSearchesData from '@/src/constants/trendingSearches.json'

import { TrendingSearches } from './trendingSearches'

interface TrendingSearchesData {
    title: string
    routes: Array<{
        origin_en: string
        origin_ar?: string
        destination_en: string
        destination_ar?: string
        href: string
    }>
}

interface TrendingSearchesWrapperProps {
    isMobile?: boolean
}

export const TrendingSearchesWrapper: React.FC<TrendingSearchesWrapperProps> = ({ isMobile = false }) => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const data = trendingSearchesData as TrendingSearchesData
    const isArabic = locale === 'ar'

    const routes = useMemo(
        () =>
            data.routes.map(route => ({
                ...route,
                origin: isArabic ? route.origin_ar || route.origin_en : route.origin_en,
                destination: isArabic ? route.destination_ar || route.destination_en : route.destination_en
            })),
        [data.routes, isArabic]
    )

    if (!data || !data.routes || data.routes.length === 0) {
        return null
    }

    // Split routes: 2 columns for mobile, 3 columns for desktop
    let leftColumnRoutes: typeof data.routes = []
    let middleColumnRoutes: typeof data.routes = []
    let rightColumnRoutes: typeof data.routes = []

    if (!isMobile) {
        // Desktop: 3 columns
        leftColumnRoutes = routes.filter((_, index) => index % 3 === 0)
        middleColumnRoutes = routes.filter((_, index) => index % 3 === 1)
        rightColumnRoutes = routes.filter((_, index) => index % 3 === 2)
    } else {
        // Mobile: 2 columns (original behavior)
        leftColumnRoutes = routes.filter((_, index) => index % 2 === 0)
        rightColumnRoutes = routes.filter((_, index) => index % 2 === 1)
    }

    return (
        <TrendingSearches
            title={t('trendingSearches')}
            leftColumnRoutes={leftColumnRoutes}
            middleColumnRoutes={middleColumnRoutes}
            rightColumnRoutes={rightColumnRoutes}
        />
    )
}

export default TrendingSearchesWrapper
